import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';

@Component({
    selector: 'language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
    standalone: false
})
export class LanguageSelectorComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private translate: TranslateService) {
    this.translate.get('general.languages');
  }

}
